<template lang="html">
  <a
    class="copy"
    @click.prevent="clearFailed()"
  >
    <span>{{ $t('ui.clear') }}</span>
    <span
      v-show="cleared"
      class="UI-icon UI-checked"
    />
  </a>
</template>

<script>
import bus from '@/bus'

export default {
  name: 'ClearFailed',

  data () {
    return {
      cleared: false
    }
  },

  methods: {
    clearFailed () {
      bus.$emit('clear-failed')
      this.cleared = true
      setTimeout(_ => {
        this.cleared = false
      }, 700)
    }
  }
}
</script>

<style lang="scss">
.copy{
  color: #A2b4b4;
  opacity: 0.4;
  cursor: pointer;
  font-size: 14px;

  &:hover{
    opacity: 0.9;
    color: white;
    span:first-of-type{
      text-decoration: underline;
    }
  }

  .UI-checked{
    color: #14c6ab;
    margin-left: 7px;
    line-height: 16px;
  }
}
</style>
